var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoicesReceived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_662cd1db2962d73881c8dae0039cb380d48b67a11418d33808614fc297eb8ee8",
    x1: 77.31,
    y1: 40.57,
    x2: 122.44,
    y2: 40.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_662cd1db2962d73881c8dae0039cb380d48b67a11418d33808614fc297eb8ee8",
    x1: 77.31,
    y1: 75.5,
    x2: 122.44,
    y2: 75.5,
    xlinkHref: "#SVGID_0_662cd1db2962d73881c8dae0039cb380d48b67a11418d33808614fc297eb8ee8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_662cd1db2962d73881c8dae0039cb380d48b67a11418d33808614fc297eb8ee8",
    x1: 77.31,
    y1: 85.85,
    x2: 122.44,
    y2: 85.85,
    xlinkHref: "#SVGID_0_662cd1db2962d73881c8dae0039cb380d48b67a11418d33808614fc297eb8ee8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_662cd1db2962d73881c8dae0039cb380d48b67a11418d33808614fc297eb8ee8",
    x1: 77.31,
    y1: 96.35,
    x2: 121.5,
    y2: 96.35,
    xlinkHref: "#SVGID_0_662cd1db2962d73881c8dae0039cb380d48b67a11418d33808614fc297eb8ee8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_662cd1db2962d73881c8dae0039cb380d48b67a11418d33808614fc297eb8ee8",
    x1: 91.57,
    y1: 106.22,
    x2: 106.98,
    y2: 106.22,
    xlinkHref: "#SVGID_0_662cd1db2962d73881c8dae0039cb380d48b67a11418d33808614fc297eb8ee8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_662cd1db2962d73881c8dae0039cb380d48b67a11418d33808614fc297eb8ee8",
    x1: 77.31,
    y1: 51.68,
    x2: 122.44,
    y2: 51.68,
    xlinkHref: "#SVGID_0_662cd1db2962d73881c8dae0039cb380d48b67a11418d33808614fc297eb8ee8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_662cd1db2962d73881c8dae0039cb380d48b67a11418d33808614fc297eb8ee8",
    x1: 77.31,
    y1: 80.6,
    x2: 122.45,
    y2: 80.6,
    xlinkHref: "#SVGID_0_662cd1db2962d73881c8dae0039cb380d48b67a11418d33808614fc297eb8ee8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M61.29 51.73H43.6V35.06a8.85 8.85 0 0117.69 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M52.68 26.34h75.79a8.74 8.74 0 018.86 8.55v25.69M154.83 120.01v16.33H44.47v-16.33M154.83 120.01V72.84l-17.54-12.26M61.32 61.05L44.47 72.84v47.17M61.32 84.48V51.73M137.29 84.77V60.58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M78.56 40.57h42.63"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M99.87 110.21V64.83"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M78.56 75.5h42.63"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M78.56 85.85h42.63"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M78.56 96.35h41.69"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M105.73 106.22H92.82"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M78.56 51.68h42.63"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_6_662cd1db2962d73881c8dae0039cb380d48b67a11418d33808614fc297eb8ee8)",
    d: "M78.56 96.38V64.83h42.64v30.88"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M154.83 72.84l-17.54 11.93-16.09 10.94-.95.64-14.52 9.87-5.86 3.99-.64.43-6.41-4.42-14.26-9.84-17.24-11.9-16.85-11.64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicesReceived);
export default __webpack_public_path__ + "static/media/invoicesReceived.d7fcb1dd1a065c2202c7dbb83d713b7e.svg";
export { ForwardRef as ReactComponent };